"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPollOutline = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M5 8c0-1.328.667-1.995 2-2h2.001V4c0-1.333.666-2 1.996-2h2.007C14.335 2.005 15 2.67 15 4v6h2c1.333 0 2 .668 2 2.004v4c0 1.33-.667 1.998-2 2.002C15 18.01 7.334 18 7 18c-1.333 0-2-.667-2-2V8zm2 0v8h2V8H7zm4-4v12h2V4h-2zm4 8v4h2v-4h-2zM5 20h14c.667 0 1 .334 1 1 0 .667-.333 1-1 1H5c-.667 0-1-.333-1-1 0-.666.333-1 1-1z' }))); };
exports.default = SvgPollOutline;
//# sourceMappingURL=PollOutline.js.map